import {addItem, removeItem} from "@/utils/listUtils";

export default {
    methods: {
        removeItem(item, list) {
            removeItem(item, list)
        },
        addItem(item, list) {
            addItem(item, list)
        }
    },
}
